import { useContext, useState } from "react";
import { useLogging } from "../../../../../Shared/hooks/useLogging/useLogging";
import { BillingInformationContext } from "../../../BillingInformationContext";
import { deactivatePaymentMethod, initPaymentMethodUpdate, updatePaymentMethod, updatePrimaryPaymentMethod, } from "./PaymentMethodUpdate-utils";
export const usePaymentMethodUpdate = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState();
    const { setClientSecret, setToken, setPublicKey, setPaymentProfileId, setCustomerCreditCards, setPaymentProcessor, customerCreditCards, } = useContext(BillingInformationContext);
    const { datadogLog } = useLogging();
    return {
        initPaymentMethodUpdate: initPaymentMethodUpdate(setLoading, setToken, setPublicKey, setClientSecret, setPaymentProfileId, setPaymentProcessor, datadogLog),
        updatePaymentMethod: updatePaymentMethod([customerCreditCards, setCustomerCreditCards], setLoading, setError, datadogLog),
        updatePrimaryPaymentMethod: updatePrimaryPaymentMethod([customerCreditCards, setCustomerCreditCards], setLoading, setError, datadogLog),
        deactivatePaymentMethod: deactivatePaymentMethod([customerCreditCards, setCustomerCreditCards], setLoading, setError, datadogLog),
        loading,
        error,
    };
};
